import * as angular from 'angular';
import * as _ from 'lodash';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import CommoditiesServiceName, {CommoditiesService} from "../../services/batches/commodities.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import template from './updateCommodity.tpl.html';

let requires = [CommoditiesServiceName, NotifyServiceName, LoaderServiceName, NewGuidServiceName];

interface UpdateCommodityController {
  save(): void;
  cancel(): void;
}

export interface UpdateCommodityParams {
  instance: apsViewModels.CommodityItem;
  allCommodities: apsViewModels.CommodityItem[];
}

export function openUpdateCommodity(data: UpdateCommodityParams,
                                    $modal: mm.foundation.modal): angular.IPromise<apsViewModels.CommodityItem> {
  return $modal.open({
    template: template,
    controller: 'UpdateCommodityCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class UpdateCommodityCtrl implements UpdateCommodityController {
  instance: apsViewModels.CommodityItem;
  form: angular.IFormController;
  allCommodities: apsViewModels.CommodityItem[];

  private $modalInstance: mm.foundation.modalInstance;
  private commoditiesService: CommoditiesService;
  private notifyService: NotifyService;
  private loaderService: LoaderService;
  private newId: string;

  constructor(
    $modalInstance: mm.foundation.modalInstance,
    commoditiesService: CommoditiesService,
    data: UpdateCommodityParams,
    notifyService: NotifyService,
    newGuidService: NewGuidService,
    loaderService: LoaderService
  ) {
    this.$modalInstance = $modalInstance;
    this.commoditiesService = commoditiesService;
    this.notifyService = notifyService;
    this.loaderService = loaderService;

    this.instance = {...data.instance};

    this.loaderService.loadingPromise(newGuidService.getNewGuid('Commodity')
      .then(id => this.newId = id));
  }

  save(): void {
    if (this.form.$invalid) {
      return;
    }

    let command = <apsCommands.UpdateCommodity>{
      ...this.instance,
      newId: this.newId
    };

    this.loaderService.loadingPromise(this.commoditiesService.update(command)
      .then(() => {
        this.$modalInstance.close(this.instance);
      }, this.notifyService.handleApiErrors)
    );
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.updateCommodity', requires)
  .controller('UpdateCommodityCtrl', UpdateCommodityCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/updateCommodity.controller.ts